import { Box, Stack, styled } from "@mui/material";
import { useCallback, useState } from "react";
import "./resizer.css";
import { hexToRgb, hexToRgbString } from "../../Utils/Helpers/cssUtils";

export interface IResizerProps {
  position: "right" | "left";
  pinned: boolean;
}
const Resizer: React.FC<IResizerProps> = ({ position, pinned }) => {
  const [hovered, setHovered] = useState(false);
  const [active, setActive] = useState(false);

  const onMouseEnter = useCallback(() => setHovered(true), []);
  const onMouseLeave = useCallback(() => setHovered(false), []);
  const onMouseDown = useCallback(() => setActive(true), []);
  const onMouseUp = useCallback(() => {
    setActive(false);
    setHovered(false);
  }, []);
  return (
    <Box
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      sx={(theme) => ({
        left: position === "left" ? "unset" : -8,
        right: position === "right" ? "unset" : -8,
        zIndex: 1,
        "&:after": {
          opacity: active || hovered ? 1 : 0,
          background: `linear-gradient(180deg, rgba(${hexToRgbString(
            theme.palette.background.inverted
          )}, 0) 0%, rgba(${hexToRgbString(theme.palette.background.inverted)}, .1) 32.55%, rgba(${hexToRgbString(
            theme.palette.background.inverted
          )}, .1) 66.6%, rgba(${hexToRgbString(theme.palette.background.inverted)}, 0) 100%)`,
          boxShadow: `0 0 2px 1px ${theme.palette.background.page} inset`,
          content: '""',
          position: "absolute",
          bottom: 0,
          left: 0,
          top: 0,
          right: 0,
          zIndex: 1,
          transition: theme.transitions.create(["opacity"], {
            duration: theme.transitions.duration.short,
            easing: theme.transitions.easing.easeInOut,
          }),
        },
      })}
      className={`resizer  resizer--r resizer-wrapper`}
    >
      {/* full window object to properly record mouseup */}
      {active && <Box sx={{ opacity: 0, position: "fixed", top: 0, bottom: 0, left: 0, right: 0 }}></Box>}
      <Stack
        className={`resizer ${
          position === "left" ? "resizer-left" : "resizer-right"
        } resizer--r resizer-content-wrapper`}
      >
        <ResizeBar active={active || hovered} />
      </Stack>
    </Box>
  );
};

const ResizeBar = styled("i", { shouldForwardProp: (prop) => prop !== "active" })<{
  active?: boolean;
}>(({ theme, active }) => ({
  display: "block",
  width: 3,
  height: 32,
  opacity: active ? 1 : 0.5,
  background: theme.palette.text.tier,
  borderRadius: 150,
  transition: theme.transitions.create(["opacity"], {
    duration: theme.transitions.duration.short,
    easing: theme.transitions.easing.easeInOut,
  }),
}));

export default Resizer;
